import React from 'react';

/**
 * Set render custom control Layer switcher
 * @returns {JSX.Element}
 * @constructor
 */
const LayerSwitcherButton = () => {
    return (
        <button className="mapboxgl-ctrl-custom-layer-switcher" type="button" title="Affichage des zones"
                aria-label="Affichage des zones"
        >
            <span className="mapboxgl-ctrl-icon" aria-hidden="true"/>
        </button>
    );
};

export default LayerSwitcherButton;